import { ArrowLeftRight } from "lucide-react";
import { canAccess, roleAccess, type AccessVerb } from "@hisense/shared";
import { useAuth } from "@/app/auth";
import { SettledRules } from "@/components/ui/SettledRules";

/**
 * Quy tắc của Biến động kho — chốt 20/09/2026 theo chuẩn (chuyển lô, giữ hàng, kiểm kê & tồn đầu, xuất / nhập bán hàng), khách bác lại
 * được. Trước đây mỗi màn có một nút "Chờ khách xác nhận" bật ra các thẻ vàng; nay là mục gập trung tính ở đầu từng màn, mỗi màn đọc
 * đúng bộ quy tắc của mình.
 */
export const TRANSFER_RULES_SETTLED = ["timing", "quality", "authority"] as const;
export const RESERVATION_RULES_SETTLED = ["hold", "consume", "scope"] as const;
export const COUNT_RULES_SETTLED = ["snapshot", "hold", "opening"] as const;
export const SALES_ISSUE_RULES_SETTLED = ["moment", "rma"] as const;

export function StockMoveRules({ ns, rules }: { ns: string; rules: readonly string[] }) {
  return <SettledRules ns={ns} rules={rules} icon={ArrowLeftRight} />;
}

/** Cùng bộ giải quyền với máy chủ (ô tick menu Biến động kho) — trước 20/09/2026 kiểm kê và xuất / nhập bán hàng chỉ mở cho quản trị viên. */
export function useStockMoveAccess() {
  const { user } = useAuth();
  const access = user ? user.access ?? roleAccess(user.role) : null;
  return (verb: AccessVerb) => !!access && canAccess(access, "stockMoves", verb);
}
